import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceGql } from './WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceGql';

export const TableDownstreamWorkbooksWithoutPersonalSpaceQueryGql: DocumentNode = gql`
query TableDownstreamWorkbooksWithoutPersonalSpaceQuery($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  tables(filter: { id: $tableId }) {
    downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
${WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceGql}
`;
